/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/settingsHelpers.ts (Callback Profiles)
 🗓️ Created: 2025-01-15
 🧩 Description:
    Settings helper functions for Callback Profiles.

────────────────────────────────────────────────────────────────*/

import { FormState } from '../types';

export const KNOWN_SETTINGS_KEYS = new Set([
  'callback_key',
  'confirm_sound',
  'thanks_sound',
  'timeout_seconds',
  'retry_interval',
  'max_attempts',
  'strategy',
  'announcement_sound'
]);

export const buildSettingsFromFormState = (formState: FormState, extraSettings: Record<string, unknown>): Record<string, unknown> => {
  const settings: Record<string, unknown> = { ...extraSettings };

  // Map form fields to settings
  settings.callback_key = formState.callbackKey.trim() || '1';
  if (formState.confirmSound.trim()) {
    settings.confirm_sound = formState.confirmSound.trim();
  }
  if (formState.thanksSound.trim()) {
    settings.thanks_sound = formState.thanksSound.trim();
  }
  settings.timeout_seconds = Number(formState.timeoutSeconds) || 3600;
  
  const retryIntervalNum = Number(formState.retryInterval);
  settings.retry_interval = Number.isFinite(retryIntervalNum) ? retryIntervalNum : 300;
  
  settings.max_attempts = Number(formState.maxAttempts) || 3;
  settings.strategy = formState.strategy;
  if (formState.announcementSound.trim()) {
    settings.announcement_sound = formState.announcementSound.trim();
  }

  return settings;
};

